import { Component, Input, OnInit } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { DepositoMovimientosModeloMLS, DepositoService, ObtenerMovimientosDepositoME, ParametrizacionService } from 'src/app/open-api';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-deposito-movimiento',
  templateUrl: './deposito-movimiento.component.html',
  styleUrls: ['./deposito-movimiento.component.scss']
})
export class DepositoMovimientoComponent implements OnInit {

  @Input() set SecuencialDeposito(secuencial: number) {
    this.secuencialDeposito = secuencial;
    this.ObtenerUsuario();
    this.ObtenerMovimientos();
  };
  movimientos: DepositoMovimientosModeloMLS[] = [];
  movimientosLista: DepositoMovimientosModeloMLS[] = [];
  usuario?: UserModel;
  hoy = new Date();
  fechaInicio = new Date(this.hoy.setDate(this.hoy.getDate() - 7));
  fechaFin = new Date();
  secuencialDeposito = 0;
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;
  minFechaInicio = new Date();
  fechaMinima = new Date();
  mesesRango = 0;

  constructor(
    private depositoService: DepositoService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private localeService: BsLocaleService,
    private parametrizacion :ParametrizacionService,
  ) {
    this.localeService.use('es');
  }

  async ngOnInit() {
    this.ObtenerUsuario();
    await this.obtenerParametrizacion()
  }

  ListarMovimientos() {
    this.movimientosLista = this.movimientos
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
  }

  ObtenerUsuario() {
    this.authService.user.subscribe(usuario => {
      this.usuario = usuario;
    })
  }

  ObtenerMovimientos() {
    this.spinner.show();
    const parametro: ObtenerMovimientosDepositoME = {
      fechaFin: this.fechaFin,
      fechaInicio: this.fechaInicio,
      secuencialDeposito: this.secuencialDeposito,
      secuencialEmpresa: this.usuario?.secuencialEmpresa
    };
    this.depositoService.apiV10DepositoObtenerMovimientosDepositoPost(parametro).subscribe(respuesta => {
      this.movimientos = respuesta.movimientosDeposito || [];
      this.cantidad = this.movimientos.length;
      this.ListarMovimientos();
      this.spinner.hide();
    });
  }

  async obtenerParametrizacion(){
    this.spinner.show();
    this.parametrizacion.apiV10ParametrizacionObtenerParametrizacionOperacionesPost().subscribe(item => {
        this.mesesRango = Number(item.operaciones?.find(g => g.id == 1)?.valor ?? 0);
      
        const ahora = new Date();
        this.minFechaInicio = new Date(ahora.getFullYear(), ahora.getMonth() - this.mesesRango, ahora.getDate());
       
        this.spinner.hide();
      
    }, error => {
        this.spinner.hide();
    });
}

}
